<template>
<div class="obj-list wrapper ofh" v-if="!loading" v-loading.fullscreen.lock="loading" :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    
     <div class="page__card">
            <div class="page__card-title">
                <h1>{{ $t('all_users') }}</h1>
            </div>
    <div class="wp-body">
        <header class="wp-header w-full">
            <div class="flex flex-wrap gap-2 w-full">
                <div class="w-full sm:w-52">
                    <el-select class="w-full" v-model="filterUser" clearable filterable remote :placeholder="`${$t('org_name')}`" :remote-method="remoteMethod" :loading="selLoading">
                            <el-option v-for="(item,i) in options" :key="i" :label="item.name_cyr" :value="item.id">
                            </el-option>
                        </el-select>
                </div>
                <div class="w-full sm:w-52">
                    <el-input class="w-full" style="margin-left: 0 !important;" :placeholder="$t('search')" prefix-icon="el-icon-search" v-model="search" @keyup.enter.native="__GET()" clearable>
                        </el-input>
                </div>
                <div class="flex-1 hidden sm:block"></div>
                <button v-if="role !== 'supervisor'" class="add__button w-full sm:w-max" @click="addUsermodal = true">
                    {{ $t('add') }}
                    <HAddCircle />
                </button>
            </div> 
        </header>
        <el-table :data="Users" class="sm:mt-5" style="margin-bottom: 20px; width: 99%;" row-key="id">
            <el-table-column label="№" width="100" align="center">
                <template slot-scope="scope">
                    {{ (current_page - 1) * item_count + (scope.$index + 1) }}
                </template>
            </el-table-column>

            <el-table-column :label="$t('username').toUpperCase()" width="300" sortable>
                <template slot-scope="scope">
                    <div>
                        <p class="fw-500 cp"> {{scope.row.login_name}} </p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :prop="`organization.name_cyr`" :label="$t('organisation_name').toUpperCase()" min-width="300" sortable>
            </el-table-column>
            <el-table-column v-if="role !== 'supervisor'" width="116" :label="$t('actions').toUpperCase()">
                <template slot-scope="scope">
                    <button
                        @click="OpenMoadl(scope.row.id, scope.row.organization, scope.row.login_name, scope.row.role)"
                        class="w-10 h-10 rounded-xl flex justify-center items-center bg-slate-100 hover:bg-slate-200 text-indigo-800">
                        <h-edit />
                    </button>
                    <!-- <button size="small" @click="OpenMoadl(scope.row.id, scope.row.organization, scope.row.login_name, scope.row.role)" class="el-icon-unlock el-button-download" plain></button> -->
                    
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="margin-left: auto; margin-top: auto" class="ml-auto" :page-sizes="[10, 20, 50, 100]" :page-size="item_count" @current-change="paginate" @size-change="paginateSize" :current-page.sync="current_page1" :hide-on-single-page="false" background layout="sizes, prev, pager, next" :page-count="page_count">
        </el-pagination>
    </div>
    <div class="user-add-modal" v-if="modal">
        <div class="user-add-cover"></div>
        <div class="user-add-modal-content">
            <div class="w-full" v-show="step==1">
                <div class="user-modal-body">
                    <h1>{{$t('user_edit')}}</h1>
                    <el-form :model="User" ref="edituser" :rules="UserRules">
                        <div class="item">
                            <el-form-item>
                                <p>{{$t('transport_table_name')}}</p>
                                <el-input :placeholder="$t('transport_table_name')" :value="organization_name ? organization_name[`name_${$i18n.locale}`] : ''" :disabled="true"/>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item>
                                <p>{{ $t('role') }}</p>
                                <template>
                                    <el-radio v-for="(item,i) in roles" :key="i" :id="`role_name`" :disabled="modalLoading" v-model="User.role" class="prim" :label="item.id" border>
                                        {{item.name=='operator'? 'Оператор':'ТИ Оператор'}}
                                    </el-radio>
                                </template>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item prop="login_name">
                                <p>{{$t('login')}}</p>
                                <div class="flex items-center gap-2">
                                    <el-input placeholder="Username" v-model="User.login_name" class="flex-1" :disabled="modalLoading || modalLoadinglogin"/>
                                    <button class="bg-slate-100 rounded-xl w-10 h-10 flex justify-center items-center" @click="GenerateLogin" type="button" :disabled="modalLoading ||modalLoadinglogin">
                                        <h-loading v-if="modalLoading ||modalLoadinglogin" class="spin"/>
                                        <h-reload v-else/>
                                    </button>
                                </div>
                            </el-form-item>
                        </div>

                        <div class="item">
                            <el-form-item prop="password">
                                <p>{{$t('password')}}</p>
                                <div class="flex items-center gap-2">
                                    <el-input placeholder="Password" v-model="User.password" class="flex-1"/>
                                    <button class="bg-slate-100 rounded-xl w-10 h-10 flex justify-center items-center" @click="Generate" type="button" :disabled="modalLoading">
                                        <h-loading v-if="modalLoading" class="spin"/>
                                        <h-reload v-else/>
                                    </button>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>

                <div class="flex justify-end gap-2 mt-8">
                    <button type="button" class="light-button" @click="Clear" :disabled="modalLoading"> {{$t('otmen')}} </button>
                    <button type="button" class="add__button" @click="UserSave" :disabled="modalLoading"> 
                        {{ $t('save') }}
                        <h-loading v-if="modalLoading" class="spin"/>
                        <h-check-circle v-else/>
                    </button>
                </div>
            </div>
            <div class="w-full" v-show="step==2">
                <div class="user-modal-body">
                    <h2> <i class="el-icon-success"></i></h2>
                    <h1>{{$t('create_user_success')}}</h1>
                    <div class="user-item-list">
                        <div class="user-data">
                            <p class="user-info-title">{{$t('login')}}:</p>
                            <p> {{User.login_name}}</p>
                            <button @click="Copy(User.login_name )"><i class="el-icon-document-copy"></i> </button>
                        </div>
                        <div class="user-data">
                            <p class="user-info-title"> {{$t('password')}}: </p>
                            <p> {{User.password}}</p>
                            <button @click="Copy(User.password)"> <i class="el-icon-document-copy"></i> </button>
                        </div>
                        <div class="user-data">
                            <p class="user-info-title">{{$t('role')}}:</p>
                            <p> {{roleNames[getRoleName(User.role)]}}</p>
                        </div>
                        <div class="user-data">
                            <p class="user-info-title"> {{$t('organisation_name')}}:</p>
                            <p>{{organization_name}}</p>
                        </div>
                    </div>

                </div>
                <div class="flex justify-end gap-2 mt-8">
                    <button type="button" class="button black" @click="CopyAll()"> <i class="el-icon-document-copy"></i> </button>
                    <button type="button" class="button dark-blue" @click="Clear"> {{$t('close')}} </button>
                </div>
            </div>
        </div>
    </div>
    <div class="user-add-modal" v-if="addUsermodal">
        <div class="user-add-cover"></div>
        <div class="user-add-modal-content">
            <div class="w-full" v-show="step==1">
                <div class="user-modal-body">
                    <h1>{{$t('create_new_user')}}</h1>
                    <el-form :model="User" ref="userAdd" :rules="UserRules">

                        <div class="item">
                            <el-form-item>
                                <p>{{$t('transport_table_name')}}</p>
                                <el-select class="w-full" v-model="organization" filterable remote :placeholder="`*${$t('transport_table_name')}`" :remote-method="remoteMethod" :loading="selLoading">
                                    <el-option v-for="(item,i) in options" :key="i" :label="item.name_cyr" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item>
                                <p>{{ $t('role') }}</p>
                                <template>
                                    <el-radio v-for="(item,i) in roles" :key="i" :id="`role_name`" :disabled="modalLoading" v-model="User.role" class="prim" :label="item.id" border>
                                      {{$t(keyTitles[item.name])}}
                                    </el-radio>

                                </template>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item prop="login_name">
                                <p>{{$t('login')}}</p>
                                <div class="flex items-center gap-2">
                                    <el-input :placeholder="`*${$t('login')}`" v-model="User.login_name" class="flex-1" :disabled="seldis || modalLoading || modalLoadinglogin"/>
                                    <button class="bg-slate-100 rounded-xl w-10 h-10 flex justify-center items-center" @click="GenerateLogin" type="button" :disabled="seldis || modalLoading ||modalLoadinglogin">
                                        <h-loading v-if="modalLoadinglogin" class="spin"/>
                                        <h-reload v-else/>
                                    </button>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="item">
                            <el-form-item prop="password">
                                <p>{{$t('password')}}</p>
                                <div class="flex items-center gap-2">
                                    <el-input :placeholder="`*${$t('password')}`" v-model="User.password" class="flex-1" :disabled="seldis || modalLoading"/>
                                    <button class="bg-slate-100 rounded-xl w-10 h-10 flex justify-center items-center" @click="Generate" type="button" :disabled="seldis || modalLoading">
                                        <h-loading v-if="modalLoading" class="spin"/>
                                        <h-reload v-else/>
                                    </button>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="flex justify-end gap-2 mt-8">
                    <button type="button" class="light-button" @click="Clear" :disabled="modalLoading"> {{$t('otmen')}} </button>
                    <button type="button" class="add__button" @click="UserSave2" :disabled="seldis || modalLoading"> 
                        {{ $t('save') }}
                        <h-loading v-if="modalLoading" class="spin"/>
                        <h-check-circle v-else class="icon"/>
                    </button>
                </div>
            </div>
            <div class="w-full" v-show="step==2">
                <div class="user-modal-body">
                    <h2> <i class="el-icon-success"></i></h2>
                    <h1>{{$t('create_user_success')}}</h1>
                    <div class="user-item-list">
                        <div class="user-data">
                            <p class="user-info-title">{{$t('login')}}:</p>
                            <p> {{User.login_name}}</p>
                            <button @click="Copy(User.login_name )"><i class="el-icon-document-copy"></i> </button>
                        </div>
                        <div class="user-data">
                            <p class="user-info-title"> {{$t('password')}}: </p>
                            <p> {{User.password}}</p>
                            <button @click="Copy(User.password)"> <i class="el-icon-document-copy"></i> </button>
                        </div>
                        <div class="user-data">
                            <p class="user-info-title">{{$t('role')}}:</p>
                            <p> {{roleNames[getRoleName(User.role)]}}</p>
                        </div>
                        <div class="user-data">
                            <p class="user-info-title"> {{$t('organisation_name')}}:</p>
                            <p>{{organization_name}}</p>
                        </div>
                    </div>

                </div>
                <div class="flex justify-end gap-2 mt-5">
                    <button type="button" class="button black" @click="CopyAll()"> <i class="el-icon-document-copy"></i> </button>
                    <button type="button" class="button dark-blue" @click="Clear"> {{$t('close')}} </button>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
<ScletonPage header="true" v-else class="m-5 p-5 bg-white rounded-3xl" />
</template>

<script>
import ScletonPage from '../../components/Scletons/Page.vue'
import GeneratedPassword from '../../components/PasswordGenerate.vue'
import GenerateLogin from '../../components/LoginGenerate.vue'
import axios from 'axios';
import HAddCircle from '../../components/Icons/hAddCircle.vue';
import HLoading from '../../components/Icons/hLoading.vue';
import HCheckCircle from '../../components/Icons/hCheckCircle.vue';
import HReload from '../../components/Icons/hReload.vue';
import HEdit from '../../components/Icons/hEdit.vue';
export default {
    components: {
        ScletonPage,
        GeneratedPassword,
        GenerateLogin,
        HAddCircle,
        HLoading,
        HCheckCircle,
        HReload,
        HEdit
    },
    data() {
        return {
            page_count: 1,
            current_page: 1,
            current_page1: 1,
            isAdmin: false,
            loading: false,
            item_count: 10,
            input2: null,
            Users: [],
            search: "",
            modal: false,
            modalLoadinglogin: false,
            step: 1,
            user_id: 0,
            addUsermodal: false,
            filterUser: '',
            User: {
                login_name: "",
                password: "",
                role: ''
            },
            UserRules: {
                login_name: [{
                        required: true,
                        message: 'Илтимос фойдаланувчи номини киритинг!',
                        trigger: 'change'
                    },
                    {
                        min: 2,
                        max: 25,
                        message: 'Логин узунлиги 2 ва 25 орасида бўлиши керак!',
                        trigger: 'change'
                    }
                ],
                password: [{
                        required: true,
                        message: 'Илтимос паролни киритинг!',
                        trigger: 'change'
                    },
                    {
                        min: 8,
                        max: 20,
                        message: 'Парол узунлиги 8 ва 25 орасида бўлиши керак!',
                        trigger: 'change'
                    }
                ],
            },
            organization: '',
            modalLoading: false,
            options: [],
            selLoading: false,
            seldis: true,
            organization_name: 'Organisation Name',
            roles: [],
            roleNames: {
                tf_operator: 'ТИ Оператор',
                operator: 'Оператор',
                no: '--'
            },
            keyTitles: {
              operator: 'operator',
              tf_operator: 'tf_operator',
              org_admin: 'org_admin',
              main_org_admin: 'main_org_admin',
            }
        };
    },
    watch: {
        organization(val) {
            if (val !== '') {
                this.seldis = false
                this.User.organization = val
                this.User.role = this.roles[0].id ? this.roles[0].id : 3
                this.organization_name = this.options.filter(item => {
                    return item.id == val
                })
                this.organization_name = this.organization_name[0] ? this.organization_name[0] : '*'
                this.Generate()
                this.GenerateLogin()
            }
        },
        filterUser() {
            this.__GET()
        }
    },
    computed: {
        me() {
            return this.$store.state.me;
        },
        role() {
            return this.$store.state.role;
        }
    },
    mounted() {
        this.loading = true
        this.current_page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
        this.search = this.$route.query.search ? this.$route.query.search : ''
        this.item_count = this.$route.query.item_count ? this.$route.query.item_count : 10
        this.__GET();
        this._Getroles()
        axios.get(`/organization/?limit=10`)
            .then(res => {
                this.options = res.data.results
            })

    },
    methods: {
        paginate(val) {
            this.current_page = val;
            this.__GET();
        },
        paginateSize(val) {
            this.item_count = val
            this.__GET();
        },
        __GET() {
            this.loading = true;
            let offset = this.item_count * (this.current_page - 1);

            if (this.$route.query.id) {
                this.isAdmin = true;
                if (this.search != '' || this.item_count != 10) {
                    this.$router.push(`/users/?id=${this.$route.query.id}&page=${this.current_page}&item_count=${this.item_count}&search=${this.search}`)
                        .catch(e => {
                            if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                                console.log(e)
                            }
                        });
                } else {
                    this.$router.push(`/users/?id=${this.$route.query.id}&page=${this.current_page}`)
                        .catch(e => {
                            if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                                console.log(e)
                            }
                        });
                }
                axios.get(`/users/?organization=${this.filterUser}&search=${this.search}&limit=${this.item_count}&offset=${offset}`)
                    .then((response) => {
                        this.Users = response.data.results;
                        this.page_count = Math.ceil(response.data.count / this.item_count);
                        this.current_page1 = this.$route.query.page ? parseInt(this.$route.query.page) : 1
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                if (this.search != '' || this.item_count != 10) {
                    this.$router.push(`/users/?page=${this.current_page}&item_count=${this.item_count}&search=${this.search}`)
                        .catch(e => {
                            if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                                console.log(e)
                            }
                        });
                } else {
                    this.$router.push(`/users/?page=${this.current_page}`)
                        .catch(e => {
                            if (e.name !== 'NavigationDuplicated' && !e.message.includes('Avoided redundant navigation to current location')) {
                                console.log(e)
                            }
                        });
                }

                axios.get(`/users/?organization=${this.filterUser}&search=${this.search}&limit=${this.item_count}&offset=${offset}`)
                    .then((response) => {
                        this.Users = response.data.results;
                        this.page_count = Math.ceil(response.data.count / this.item_count);
                        this.current_page1 = this.$route.query.page ? parseInt(this.$route.query.page) : 1

                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        remoteMethod(query) {
            if (query !== '') {
                this.selLoading = true
                axios.get(`/organization/?search=${query}`)
                    .then((response) => {
                        this.options = response.data.results.length > 0 ? response.data.results : []
                    })
                    .catch(() => {
                        this.options = []
                    })
                    .finally(() => {
                        this.selLoading = false;
                    })
            } else {
                this.options = [];
            }
        },
        OpenMoadl(id, name, username, role) {
            this.modal = true
            this.organization_name = name
            this.User.login_name = username
            this.User.role = role.id
            this.user_id = id
        },
        Clear() {
            this.step = 1
            this.organization_name = '',
                this.User = {
                    login_name: "",
                    password: "",
                    role: this.roles[0].id
                }
            this.organization = ''
            if(this.$refs.userAdd){
                this.$refs.userAdd.resetFields()
            }
            if(this.$refs.edituser){
                this.$refs.edituser.resetFields()
            }


            this.User.password = ''
            this.modal = false
            this.user_id = 0
            this.addUsermodal = false
        },
        UserSave() {
            this.$refs.edituser.validate(valid => {
                if (valid) {
                    this.modalLoading = true
                    axios.patch(`/users/${this.user_id}/`, this.User)
                        .then(response => {
                            this.modal = false
                            this.step = 2
                            this.organization_name = this.organization_name && this.organization_name != null && this.organization_name.name_cyr ? this.organization_name.name_cyr : '***'
                            this.$swal.fire({
                                icon: 'success',
                                title: this.$t('create_user_success'),
                                timer: 3000
                            }).then(() => {
                                this.modal = true
                            })

                        })
                        .finally(() => {
                            this.modalLoading = false
                        })
                }
            })

        },
        CopyAll() {
            var item = `Логин: ${this.User.login_name}, \nПароль: ${this.User.password}, \nТашкилот: ${this.organization_name}`
            var a = this.$copyText(item)
            a ? this.$swal.fire({
                icon: 'success',
                title: this.$t('copy_success'),
                timer: 3000
            }) : this.$swal.fire({
                icon: 'error',
                title: this.$t('error_ser'),
                timer: 3000
            })
            this.Clear()
        },
        Copy(item) {
            var a = this.$copyText(item)
            a ? this.$swal.fire({
                icon: 'success',
                title: this.$t('copy_success'),
                timer: 3000
            }) : this.$swal.fire({
                icon: 'error',
                title: this.$t('error_ser'),
                timer: 3000
            })
        },
        Generate() {
            let charactersArray = 'a-z'.split(',')
            let CharacterSet = ''
            let password = ''
            let size = 12
            charactersArray = 'a-z,A-Z,0-9,#'.split(',')
            if (charactersArray.indexOf('a-z') >= 0) {
                CharacterSet += 'abcdefghijklmnopqrstuvwxyz'
            }
            if (charactersArray.indexOf('A-Z') >= 0) {
                CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
            }

            if (charactersArray.indexOf('0-9') >= 0) {
                CharacterSet += '0123456789'
            }
            if (charactersArray.indexOf('#') >= 0) {
                CharacterSet += '![]{}()%&*$#^<>~@|'
            }
            for (let i = 0; i < size; i++) {
                password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length))
            }
            this.User.password = password
        },
        GenerateLogin() {
            let charactersArray = 'a-z'.split(',')
            let CharacterSet = ''
            let user = ''
            let size = 4
            if (charactersArray.indexOf('a-z') >= 0) {
                CharacterSet += 'abcdefghijklmnopqrstuvwxyz'
            }
            if (charactersArray.indexOf('A-Z') >= 0) {
                CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
            }

            if (charactersArray.indexOf('0-9') >= 0) {
                CharacterSet += '0123456789'
            }
            if (charactersArray.indexOf('#') >= 0) {
                CharacterSet += '![]{}()%&*$#^<>~@|'
            }
            for (let i = 0; i < size; i++) {
                user += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length))
            }
            var id = this.organization_name && this.organization_name != null && this.organization_name.id ? this.organization_name.id : ''
            user = 'user_' + id + user

            this.modalLoadinglogin = true

            axios.get(`/users?search=${user}`)
                .then(res => {
                    if (res.data.results.length < 1) {
                        this.User.login_name = user
                        this.modalLoadinglogin = false
                    } else {
                        this.GenerateLogin()
                    }
                })
                .catch(() => {
                    this.modalLoadinglogin = false
                })
        },
        UserSave2() {
            this.modalLoading = true
            axios.get(`/users?search=${this.User.login_name}`)
                .then((res) => {
                    if (res.data.results.length < 1) {
                        axios.post('/users/', this.User)
                            .then(response => {
                                this.modal = false
                                this.step = 2
                                this.organization_name = this.organization_name.name_cyr
                                this.$swal.fire({
                                    icon: 'success',
                                    title: this.$t('create_user_success'),
                                    timer: 3000
                                }).then(() => {
                                    this.modal = true
                                })

                            })
                            .finally(() => {
                                this.modalLoading = false
                            })
                    } else {
                        this.modalLoading = false
                    }
                })

        },
        _Getroles() {
            axios.get('/role/views')
                .then(res => {
                    this.roles = res.data
                    this.User.role = res.data[0].id
                })
        },
        getRoleName(id) {
            let a = 'no'
            this.roles.forEach(element => {
                if (element.id == id) {
                    a = element.name
                }
            })
            return a
        }
    },
};
</script>

<style lang="scss" scoped>

.disabled-button {
    opacity: 0.8;
    cursor: not-allowed !important;
}

.user-add-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;

    .user-add-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.5;
        z-index: 0;
    }

    .user-add-modal-content {
        max-width: 600px;
        width: 100%;
        background: #fff;
        z-index: 1;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        padding: 28px;
    }

    .user-add-modal-header {
        h1 {
            font-size: 24px;
            font-weight: 700;
        }
    }

    .user-modal-body {
        .el-radio__label{
          padding-left: 2px;
        }
        h1 {
            font-size: 24px;
            font-weight: 700;
            margin-bottom: 20px;
        }

        h2 {
            font-size: 80px;
            text-align: center;
            color: green;
        }

        .item {
            p {
                margin: 0;
                padding: 0;
                font-size: 16px;
                font-weight: 600;
                line-height: 22px;
                margin-bottom: 6px;
                color: #1E293B;
            }

            .el-form-item {
                margin-bottom: 15px !important;
            }
        }

    } 

    .user-data {
        display: flex;
        align-items: center;
        padding: 5px 0px;

        .user-info-title {
            margin-right: 10px;
            min-width: 120px;
            font-weight: 600;
        }

        p {
            font-size: 14px;
        }

        button {
            margin-left: 10px;
            font-size: 14px;
            width: 30px;
            height: 30px;
        }
    }

}
</style>
